import { CustomButton } from "@/components/custom/custom-button";
import { Box, Chip, styled, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useFormik } from "formik";
import { FormTextInput } from "@/components/custom/custom-form-text-input";
import { routeConfigItemSchema } from "@/schemas/routing.schema";

const ChipsRow = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: theme.spacing(0.75),
  marginBottom: theme.spacing(1.5),
  minHeight: 32,
}));

const AddRow = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1),
  alignItems: "flex-start",
}));

const SectionLabel = styled(Typography)(({ theme }) => ({
  fontSize: "0.8rem",
  fontWeight: 600,
  color: theme.palette.text.secondary,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  marginBottom: theme.spacing(1),
}));

export const TagSection = ({ label, items, onRemove, onAdd }) => {
  const formik = useFormik({
    initialValues: { code: "", name: "" },
    validationSchema: routeConfigItemSchema,
    validateOnChange: false,
    onSubmit: (values, { resetForm }) => {
      const duplicate = items.some(
        (i) => i.code.toLowerCase() === values.code.trim().toLowerCase(),
      );
      if (duplicate) {
        formik.setFieldError("code", "Code already exists.");
        return;
      }
      onAdd({
        code: values.code.trim().toUpperCase(),
        name: values.name.trim(),
      });
      resetForm();
    },
  });

  return (
    <Box>
      <SectionLabel>{label}</SectionLabel>

      <ChipsRow>
        {items.length === 0 && (
          <Typography variant="caption" color="text.disabled">
            No items yet.
          </Typography>
        )}
        {items.map((item) => (
          <Chip
            key={item.code}
            label={item.code}
            title={item.name}
            size="small"
            onDelete={() => onRemove(item.code)}
            sx={{ borderRadius: "6px", fontSize: "0.78rem" }}
          />
        ))}
      </ChipsRow>

      <AddRow>
        <Box sx={{ width: 110 }}>
          <FormTextInput formik={formik} name="code" label="Code" />
        </Box>
        <Box sx={{ flex: 1 }}>
          <FormTextInput formik={formik} name="name" label="Name" />
        </Box>
        <CustomButton
          size="small"
          onClick={formik.handleSubmit}
          variantType="secondary"
          sx={{ height: 37, px: 1.5, minWidth: "unset", mt: 0.1 }}
        >
          <AddIcon fontSize="small" />
        </CustomButton>
      </AddRow>
    </Box>
  );
};
